// app/javascript/controllers/accordion.js
export function bindAccordionOnce() {
    if (window.__stintAccordionBound) return;
    window.__stintAccordionBound = true;

    // Click handler for any .accordion inside #forget-part-time (delegated)
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('#forget-part-time .gfk .accordion');
        if (!btn) return;

        e.preventDefault();
        if (!btn.hasAttribute('type')) btn.setAttribute('type', 'button');

        const panel = btn.nextElementSibling;
        if (!panel) return;

        const willOpen = !btn.classList.contains('active');
        btn.classList.toggle('active', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.style.maxHeight = willOpen ? panel.scrollHeight + 'px' : null;
    });

    // On page show (BFCache) or initial load, restore open heights from aria-expanded
    const restore = () => {
        document
            .querySelectorAll('#forget-part-time .gfk .accordion[aria-expanded="true"]')
            .forEach((btn) => {
                const panel = btn.nextElementSibling;
                if (panel) {
                    btn.classList.add('active');
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
    };

    // Initial
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', restore, { once: true });
    } else {
        restore();
    }

    // BFCache restore
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) restore();
    });
}